import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';

import { CouponsService } from './coupons';

export const Ng1CouponsModule = angular
    .module('control-room.shared.services.coupons', [])
    .factory('crCouponsService',downgradeInjectable(CouponsService));
